export default {
    menu: {
        dashboard: 'Dashboard',
        users: 'Customers',
        transactions: 'Transactions',
        coupons: 'Discount coupons',
        notifications: 'Notifications',
        foods: 'Food Database',
        marketplaceProfiles: 'vresdiatrofologo',
        educational: 'Athlisis Educational',
    },
    educational: {
        title: 'Athlisis Educational',
        subtitle: 'Educational user stats by institution',
        allInstitutions: 'All institutions',
        none: 'No students yet',
        cards: {
            students: 'Students',
            athletes: 'Customers',
            dietPlans: 'Diet plans',
        },
        table: {
            institution: 'Institution',
            entryYear: 'Entry year',
        },
    },
    marketplaceProfiles: {
        title: 'Vresdiatrofologo profiles',
        viewUsers: 'View users',
        viewUser: 'View',
        published: 'Published',
        unpublished: 'Unpublished',
        date: 'Enabled at',
        actions: {
            seeProfile: 'User profile',
            seePublic: 'Vresdiatrofologo',
        },
        counts: {
            total: 'Total',
            published: 'Published',
            unpublished: 'Unpublished',
        },
        filters: {
            all: 'All profiles',
            published: 'Published only',
            unpublished: 'Unpublished only',
        },
    },
    dashboard: {
        customers: 'Εγγεγραμένοι πελάτες (με ή χωρίς συνδρομή)',
        active: 'Ενεργοί πελάτες (με συνδρομή)',
        inactive: 'Ανενεργοί πελάτες (με συνδρομή)',
        foods: 'Τρόφιμα',
        dps: 'Διατροφικά πλάνα',
        clientele: 'Πελάτες',
        viewUsers: 'Προβολή χρηστών',
        sales: 'Sales',
        renewals: 'Renewals',
        salesTitle: 'Sales & renewals per year'
    },
    users: {
        title: 'Λίστα πελατών',
        subscription: 'Συνδρομή;',
        googleLogin: 'Google Login',
        subscriptionExpiry: 'Λήξη ετήσιας συνδρομής',
        date: 'Ημερομηνία δημιουργίας',
        filters: {
            all: 'All users',
            premiumActive: 'Active subscribers',
            premiumExpired: 'Expired subscriptions',
            notPremium: 'No subscription',
            paused: 'Paused'
        },
        actions: {
            activate: 'Ενεργοποίηση συνδρομής',
            extend: ' Επέκταση ετήσιας συνδρομής (1 έτος)',
            pause: 'Παύση λογαριασμού',
            resume: 'Επανενεργοποίηση λογαριασμού',
            changeMail: 'Αλλαγή e-mail',
            transactionHistory: 'Ιστορικό συναλλαγών χρήστη'
        },
        emailPlaceholder: 'Εισάγετε το νέο e-mail',
        changeMailBtn: 'Αλλαγή e-mail',
        activate: {
            title: 'Θέλετε σίγουρα να ενεργοποιήσετε τη συνδρομή;',
            body: 'Θα προστεθεί υποχρέωση ανανέωσης της συνδρομής μετά το 1 έτος',
            okText: 'Ενεργοποίηση',
            success: 'Ο χρήστης ενεγοποιήθηκε επιτυχώς'
        },
        extend: {
            title: 'Θέλετε σίγουρα να επεκτείνετε τη συνδρομή;',
            body: 'Θα προστεθεί 1 έτος στη συνδρομή του χρήστη',
            okText: 'Επέκταση',
            success: 'Η συνδρομή επεκτάθηκε επιτυχώς!'
        },
        pause: {
            title: 'Pause this account?',
            body: 'The user will not be able to log in until reactivated.'
        },
        unpause: {
            title: 'Reactivate this account?',
            body: 'The user will be able to log in again.'
        },
        details: {
            tabs: {
                basic: 'Details',
                education: 'Educational',
                transactions: 'Transactions'
            },
            back: 'Back to list',
            loading: 'Loading...',
            overview: 'User info',
            subscription: 'Subscription',
            transactions: 'Transactions',
            noTransactions: 'No transactions',
            phone: 'Phone',
            emailConfirmed: 'Email confirmed',
            paused: 'Paused',
            expired: 'Expired',
            instalmentsSettled: 'Instalments settled',
            instalments: 'Instalments',
            instalment: 'Instalment',
            status: 'Status',
            dueDate: 'Due date',
            statuses: {
                PENDING: 'Pending',
                COMPLETED: 'Completed',
                FAILED: 'Failed',
                WAIVED: 'Waived'
            },
            education: {
                title: 'Institution & limits',
                notStudent: 'This user is not enrolled in an institution.',
                attach: 'Attach to institution',
                remove: 'Remove from institution',
                institution: 'Institution',
                entryYear: 'Entry year',
                graduationYear: 'Expected graduation',
                studentId: 'Student ID',
                limits: 'Account limits',
                limitsSource: 'institution defaults',
                limitsHint: 'Leave blank to inherit the institution default.',
                editTitle: 'Student details',
                selectInstitution: 'Select institution',
                sources: {
                    override: 'Custom',
                    institution: 'Institution default',
                    default: 'System default',
                    unlimited: 'No limit'
                },
                resources: {
                    athletes: 'Customers',
                    dietPlans: 'Diet plans',
                    recipes: 'Recipes',
                    foods: 'Foods',
                    athleteDietPlans: 'Diet plans per customer'
                },
                removeConfirm: {
                    title: 'Remove from institution?',
                    body: 'The user reverts to a regular account and loses student limits. History is preserved.'
                }
            }
        }
    },
    coupons: {
        ofCoupon: 'Κουπονιού',
        title: 'Κουπόνια Προσφοράς / Συνεργατών',
        code: 'Κωδικός κουπονιού',
        type: {
            title: 'Τύπος έκπτωσης',
            sale: 'Τιμή πώλησης (π.χ. 1240€)',
            percentage: 'Έκπτωση (π.χ. -100€)',
        },
        price: 'Τιμή αγοράς',
        partnerCode: 'Κωδικός συνεργάτη',
        partnerCodePlaceholder: 'Κωδικός πρόσβασης συνεργάτη (συστήνεται η δημιουργία του)',
    },
    transactions:{
        title: 'Λίστα συναλλαγών (ολοκληρωμένες πληρωμές μέσω Stripe)',
        invoiceDetails: 'Στοιχεία Τιμολόγησης',
        email: 'E-mail πελάτη',
        amount: 'Ποσό',
        datePayment: 'Ημερομηνία πληρωμής',
        types: {
            title: 'Είδος πληρωμής',
            renew: 'Ανανέωση',
            purchase: 'Αγορά λογισμικού',
            purchaseInstalment: 'Purchase instalment'
        },
        document: {
            title: 'Παραστατικό',
            invoice: 'Τιμολόγιο',
            receipt: 'Απόδειξη'
        },
        statusChange: {
            tooltip: 'Αλλαγή κατάστασης',
            title: 'Θέλετε σίγουρα να αλλάξετε την κατάσταση;',
            body: 'Η κατάσταση θα αλλάξει σε {status}.',
            toLabel: 'Αλλαγή σε {status}',
            okText: 'Αλλαγή'
        },
        dueDateChange: {
            tooltip: 'Change due date',
            title: 'Change due date',
            label: 'New due date',
            placeholder: 'Pick a date',
            okText: 'Save',
            renewWarning: "The user's subscription expiry date will also be updated."
        }
    },
    notifications: {
        title: 'Notifications',
        icon: 'Icon',
        add: 'Add notification',
        empty: 'No system announcements yet',
        emptyText: 'Announcements you create will show up here.',
        fieldTitle: 'Title',
        content: 'Content',
        default: 'Default',
    },
    foods: {
        list: 'List',
        title: 'System Foods',
    }

}